import { LOCATION_CHANGE } from 'connected-react-router';

import { ALERTS_SHOW_ALERT, ALERTS_HIDE_ALERT, ALERTS_PARTIAL_HIDE_ALERT } from '../alerts.types';

export const initialState = {
    isAlertOpen: false,
    isDismissible: true,
    isNewTab: false,
};

export default (state = initialState, action) => {
    const { type, payload } = action;
    const { isDismissible, isNewTab } = state;

    switch (type) {
        case ALERTS_SHOW_ALERT:
            return {
                isDismissible,
                isNewTab,
                ...payload,
                isAlertOpen: true,
            };

        case ALERTS_PARTIAL_HIDE_ALERT: // useful for delays/transitions
            return {
                ...state,
                ...initialState,
            };

        case ALERTS_HIDE_ALERT:
            return initialState;

        case LOCATION_CHANGE:
            if (!state.sticky) {
                return initialState;
            }
            return state;
        default:
            return state;
    }
};
